<div class="white-bg">
  <div *ngIf="!search.hidden" class="container banner-search">
    <div class="provider-phone-numbers hidden-xs hidden-sm">
      <a href="tel:+13367169253">336-716-WAKE (9253)</a>
      <a href="tel:+18887169253">888-716-9253 (toll-free)</a>
    </div>
    <h1>Find a Provider</h1>
    <div class="searchbox">
      <wfbhsearch-searchbox [keywords]="keywords">
      </wfbhsearch-searchbox>
    </div>
  </div>
</div>
<div class="container search-page">
  <div *ngIf="!showNoResultsOnly()" class="row">
    <div class="col-md-3">
      <wfbhsearch-facets [showFacets]="filterSortVisible" [lockFacet]="lockFacet" (facetsHidden)="onFacetsHidden()">
      </wfbhsearch-facets>
    </div>
    <div class="col-md-9">
      <div class="row">
        <div class="filter-sort col-xs-6">
          <a (click)="showFilterSort()" class="show-filter-sort"><i class="fa fa-sliders"></i> Filter &amp; Sort</a>
        </div>
        <div class="col-xs-6 col-md-12 search-info-container">
          <wfbhsearch-search-info>
          </wfbhsearch-search-info>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <wfbhsearch-active-facets></wfbhsearch-active-facets>
        </div>
        <div class="col-md-3">
          <wfbhsearch-sort [ngClass]="{show: filterSortVisible}">
          </wfbhsearch-sort>
        </div>
      </div>
      <div *ngIf="showResults()">
        <wfbhsearch-search-results>
        </wfbhsearch-search-results>
      </div>
    </div>
  </div>

  <div *ngIf="showNoResultsOnly()" class="row">
    <div class="col-sm-12">
      <wfbhsearch-search-results></wfbhsearch-search-results>
    </div>
  </div>
</div>